import { ComponentProps } from "react";
import { RouteFactory } from "@app/routePaths";
import { BrightcoveVideo } from "@components/Brightcove/utils/types";
import Card from "@particles/card/Card";
import { VideoCardProps } from "@routes/Videos/VideosPage/utils/types";
import { textToSlug } from "@util/helpers";
import dayjs from "dayjs";

/**
 * Returns the card props for the More Videos component.
 * @param videos - The videos to be displayed in the component.
 * @returns {ComponentProps<typeof Card>[]} - The card props for the More Videos component.
 */
export const getMoreVideoCardProps = (
  videos: BrightcoveVideo[],
  isDisplayKicker?: boolean
): ComponentProps<typeof Card>[] => {
  const cardProps = videos.map(({ id, name, images, duration }) => {
    const imgSrc = images.thumbnail?.src;

    const props: ComponentProps<typeof Card> = {
      id,
      title: name,
      link: `/videos/${textToSlug(name)}/${id}`,
      thumbnail: imgSrc
        ? {
            src: imgSrc,
            alt: name,
            width: 1200,
            height: 675,
          }
        : undefined,
      kicker: isDisplayKicker
        ? dayjs.duration(duration).format("HH:mm:ss")
        : undefined,
    };

    return props;
  });

  return JSON.parse(JSON.stringify(cardProps));
};

/**
 * Returns the card props for the Featured Video component.
 */
export const getFeaturedVideoCardProps = (
  videos: BrightcoveVideo[],
  isDetailsPage?: boolean
): VideoCardProps[] => {
  const videoCardProps = videos.map(
    ({ id, name, images, duration, description, published_at }) => {
      const imgSrc = images.thumbnail?.src;

      return {
        id,
        title: name,
        description,
        thumbnail: imgSrc,
        duration: isDetailsPage
          ? duration
          : dayjs.duration(duration).format("HH:mm:ss"),
        videoUrl: `${RouteFactory.videos}/${textToSlug(name)}/${id}`,
        publishedAt: isDetailsPage ? published_at : undefined,
      };
    }
  );

  return JSON.parse(JSON.stringify(videoCardProps));
};
